<breadcrumbs
  [breadcrumbs]="[
    { label: 'ADMIN', url: '/admin' },
    { label: 'STREET_TYPES', url: '/admin/street-types' },
    { label: 'CREATE_STREET_TYPE' }
  ]"
></breadcrumbs>

<page-header title="Create street type"></page-header>

<card>
  <form class="form" (submit)="onSubmit($event)">
    <div class="field is-narrow">
      <label class="label" translationEditableDirective="NAME">{{
        'NAME' | translate
      }}</label>
      <div class="control">
        <input
          class="input is-small"
          name="name"
          type="text"
          (input)="handleFieldChange($event)"
          [value]="getField(['name'])"
          [ngClass]="{ 'is-danger': hasError('name') }"
        />
      </div>
      <p class="help is-danger" *ngIf="hasError('name')">
        {{ getError('name') }}
      </p>
    </div>
  </form>
</card>

<div class="field is-grouped px-3">
  <div class="control">
    <button
      [disabled]="isLoading"
      type="submit"
      class="button is-success"
      (click)="onSubmit($event)"
      translationEditableDirective="SUBMIT"
    >
      {{ 'SUBMIT' | translate }}
    </button>
  </div>
  <div class="control">
    <a
      [routerLink]="['/admin/street-types']"
      class="button is-link is-light"
      translationEditableDirective="CANCEL"
    >
      {{ 'CANCEL' | translate }}
    </a>
  </div>
</div>
